import React from "react"
import { Helmet } from "react-helmet"
import Layout from "../../../components/Layout"
import Header from "../../../components/Header"
import CaseStudy, {
  CASE_STUDY_TYPES,
} from "../../../components/case-study/CaseStudy"
import ThumbnailImage from "../../../images/thumbnails/umagine_case_study_thumb.png"

export function Index() {
  return (
    <Layout
      title="Umagine Event Transformation with Premagic AI Photo Technology"
      description="How Umagine transformed their event experience through AI-powered photo sharing and real-time attendee engagement using Premagic."
      metaImage={ThumbnailImage}
      keywords={[
        "Umagine case study, creative industry events, design conference photos, creative networking events, innovation summit photos, creative community events, design industry networking, creative technology events, innovation conference management, creative event solutions, design community building, creative industry technology, innovation event photos, creative networking platform, design conference technology",
      ]}
      breadcrumbs={[
        { name: "Home", url: "/" },
        { name: "Case Studies", url: "/case-study/" },
        { name: "Umagine", url: "/case-study/umagine/" },
      ]}
    >
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Article",
            "headline": "Umagine Event Transformation with Premagic AI Photo Technology",
            "description": "How Umagine transformed their event experience through AI-powered photo sharing and real-time attendee engagement using Premagic.",
            "image": "https://premagic.com" + ThumbnailImage,
            "author": {
              "@type": "Organization",
              "name": "Premagic",
            },
            "publisher": {
              "@type": "Organization",
              "name": "Premagic",
              "logo": {
                "@type": "ImageObject",
                "url": "https://premagic.com/icons/icon-144x144.png",
              },
            },
            "datePublished": "2024-01-15",
            "dateModified": "2025-01-15",
          })}
        </script>
      </Helmet>
      <Header />
      <CaseStudy type={CASE_STUDY_TYPES.UMAGINE} />
    </Layout>
  )
}

export default Index
